import qs from 'qs';
import request from '@/config/request';

/*
  获取兑换商品列表
  productName
*/
export function getExchangeProductList({ page, pageSize, ...rest }) {
  return request({
    url: `/exchange/getExchangeProductList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  添加兑换商品
  productName, productIntroduce,exchangeIntegral,productSort,productUrl
*/
export function addExchangeProduct(rest) {
  return request({
    url: '/exchange/addExchangeProduct',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  查看兑换商品详情
  id
*/
export function getExchangeProduct(id) {
  return request({
    url: '/exchange/getExchangeProduct',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  编辑兑换商品
  id,productName, productIntroduce,exchangeIntegral,productSort,productUrl
*/
export function updateExchangeProduct(rest) {
  return request({
    url: '/exchange/updateExchangeProduct',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  兑换上下架
  id
*/
export function updateExchangeProductUpAndDown(id) {
  return request({
    url: '/exchange/updateExchangeProductUpAndDown',
    method: 'post',
    data: qs.stringify({
      id,
    }),
  });
}
// 积分订单
export function getExchangeOrderList(rest) {
  return request({
    url: '/integralOrder/getAdminAllIntegralOrders',
    method: 'post',
    data: qs.stringify(rest),
  });
}
// 积分订单统计
export function getCountParams() {
  return request({
    url: '/integralOrder/getCountParams',
    method: 'post',
  });
}
// 积分订单导出
export function exportOrders(params) {
  return request({
    url: '/integralOrder/export',
    method: 'get',
    params,
    responseType: 'blob',
  });
}
// 添加物流
export function addExpressCompany(data) {
  return request({
    url: '/integralOrder/addExpressCompany',
    method: 'post',
    data: qs.stringify(data),
  });
}
// 订单转换
export function replaceOrder(data) {
  return request({
    url: '/integralOrder/replaceOrder',
    method: 'post',
    data: qs.stringify(data),
  });
}
// 订单详情
export function getIntegralOrderById(data) {
  return request({
    url: '/integralOrder/getIntegralOrderById',
    method: 'post',
    data: qs.stringify(data),
  });
}
